
























import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import CoreIcon from './CoreIcon.vue'

@Component({
    components: { CoreIcon },
})
export default class CoreCheckbox extends Vue {
    @Prop({ default: false }) public defaultValue!: boolean
    @Prop({ default: false }) public disabled!: boolean
    @Prop({ default: '' }) public label!: string
    @Prop() public value!: boolean
    @Prop() public color!: string
    @Prop({ default: false }) public reset?: boolean

    public innerValue = false

    public toggle() {
        if (this.disabled) {
            return
        }
        this.innerValue = !this.innerValue
        this.value ? this.onInput() : this.onChange()
    }

    @Watch('value')
    public valueWatcher(e) {
        this.innerValue = e
    }

    @Emit('input')
    @Emit('change')
    public onChange() {
        return this.innerValue
    }

    @Emit('input')
    public onInput() {
        return this.innerValue
    }

    public mounted() {
        this.innerValue = this.defaultValue || this.value
        if (this.color) {
            const el = this.$el as HTMLElement
            el.style.setProperty('--checkbox-color', this.color)
            el.style.setProperty('--checkbox-border-color', this.color)
        }
    }

    @Watch('reset')
    public resetValue() {
        if (this.innerValue) {
            this.innerValue = false
        }
    }
}
